import {useMemo, useCallback} from 'react';
import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
import quarterOfYear from 'dayjs/plugin/quarterOfYear';

dayjs.extend(isBetween);
dayjs.extend(quarterOfYear);

export const usePeriodHook = (disableFuturePeriods?: boolean) => {
  const isPeriodEnabled = true;

  const periods = useMemo(() => {
    const now = dayjs();
    const currentYear = now.year();

    function formatDate(date: any) {
      return date.format('MM/DD/YYYY');
    }

    const periods: any = [];
    for (let i = 0; i < 4; i++) {
      const quarterStartMonth = i * 3;
      const periodStart = dayjs(new Date(currentYear, quarterStartMonth, 1));
      const periodEnd = periodStart.clone().add(2, 'month').endOf('month');
      const quarterName = `Q${i + 1} ${periodStart.year()} (${periodStart.format(
        'DD MMMM',
      )} - ${periodEnd.format('DD MMMM')})`;

      const period = {
        value: formatDate(periodStart),
        label: quarterName,
        starts: dayjs(periodStart).format('MM/DD/YYYY'),
        period: `Q${i + 1} ${periodStart.year()}`,
        ends: dayjs(periodEnd).format('MM/DD/YYYY'),
        disabled: false,
      };

      if (disableFuturePeriods && periodStart.isAfter(now, 'day')) {
        continue;
      }
      periods.push(period);
    }
    return [
      ...periods,
      {
        label: `Custom timeline`,
        value: 'custom',
        disabled: false,
      },
    ];
  }, [disableFuturePeriods]);

  // Find the current period range

  const currentMonthRange = useCallback(() => {
    const now = dayjs();

    return (
      periods.find((period) => {
        if (!period.starts || !period.ends) return false;
        return now.isBetween(
          dayjs(period.starts),
          dayjs(period.ends),
          'day',
          '[]',
        );
      }) || {
        value: '',
        label: '',
        starts: '',
        ends: '',
        period: '',
      }
    );
  }, [periods]);

  const getPeriod = (startDate: string) => {
    return periods.find((period) => period.value === startDate);
  };

  const currentPeriod = useMemo(
    () => ({
      starts: currentMonthRange().starts,
      ends: currentMonthRange().ends,
      period: currentMonthRange().period,
    }),
    [currentMonthRange],
  );

  return {
    periods,
    currentMonthRange,
    getPeriod,
    isPeriodEnabled,
    currentPeriod,
  };
};
